import styled from "styled-components";
import { Theme } from "theme";
import { Time } from "../styles";

export const RaceTime = styled(Time)<{ dnfAdjusted: boolean }>`
  ${({ dnfAdjusted }) => dnfAdjusted && `color: ${Theme.dnfTimeColor};`}
`;

export const DriverNameSpan = styled.span`
  font-size: 10pt;
  color: gray;
  white-space: pre-wrap;
  @media (max-width: 1000px) {
    font-size: 9.5pt;
  }
`;
